/* PDP Pattern — claw-slash reveal for .pdp-pattern-scratch accents.
   Loaded only on PDPs tagged 'pdp-pattern' (see layout/theme.liquid).
   One-time trigger per element via IntersectionObserver: adds
   .is-revealed (which plays the CSS keyframe in pdp-pattern.css) the
   first time each scratch scrolls into view, then stops observing it.

   Deliberately no MutationObserver: both scratch elements are rendered
   server-side by Liquid and exist in the DOM at DOMContentLoaded, so one
   querySelectorAll pass here is enough. The only gap this leaves is if
   something later replaces buy-buttons.liquid's markup wholesale (e.g. a
   variant-change re-render) — the new node just won't have replayed the
   intro animation, but it's still fully visible via the default (no
   .is-revealed) CSS state, so nothing breaks. A MutationObserver would
   close that cosmetic gap but means watching the DOM continuously for a
   decorative animation — not worth the INP/CLS risk. */
(function () {
  /* Pin each [data-bleed-edge] scratch flush against the TRUE viewport
     edge, regardless of how much padding sits between it and <body> at
     any given breakpoint/theme change. A fixed CSS px offset (e.g.
     right: -25px) is a guess at that padding sum and breaks the moment
     the guess is wrong in either direction — either it doesn't reach the
     edge, or it overshoots and causes horizontal page scroll (both
     happened here). Measuring the live gap with getBoundingClientRect
     and cancelling exactly that gap is correct for any nesting, with no
     guessing. data-bleed-edge value is "left" or "right".
     CSS still gives each accent a small default right/left as a
     no-JS fallback — see pdp-pattern.css.

     Mobile-only: true viewport-edge bleed only makes sense on the
     mobile single-column PDP layout, where content already runs nearly
     edge-to-edge. On desktop the PDP is a centered, narrower layout with
     open space on either side, so pulling the accent all the way to the
     real browser window edge looks detached from the card/button it's
     decorating — there it instead gets a small fixed local overlap
     (DESKTOP_OFFSET below) instead of the true edge-bleed. 749px matches
     this theme's standard mobile breakpoint (see e.g. combo-selling.css). */
  var MOBILE_BREAKPOINT = 749;
  var DESKTOP_OFFSET = { left: -10, right: -15 };

  function pinToEdge(el) {
    var side = el.getAttribute('data-bleed-edge');
    if (side !== 'left' && side !== 'right') return;

    if (window.innerWidth > MOBILE_BREAKPOINT) {
      el.style[side] = DESKTOP_OFFSET[side] + 'px';
      el.style.visibility = 'visible';
      return;
    }

    el.style[side] = '0px';
    var rect = el.getBoundingClientRect();
    var gap = side === 'right'
      ? window.innerWidth - rect.right
      : rect.left;
    el.style[side] = (-gap) + 'px';
    // CSS starts this hidden (see pdp-pattern.css) specifically so the
    // only paint the browser ever does is at this final position — set
    // visible only now, after positioning, so there's no visible jump.
    el.style.visibility = 'visible';
  }

  function pinAllEdgeBleeds() {
    document.querySelectorAll('[data-bleed-edge]').forEach(pinToEdge);
  }

  function init() {
    pinAllEdgeBleeds();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(pinAllEdgeBleeds, 150);
    });

    var scratches = document.querySelectorAll('.pdp-pattern-scratch');
    if (!scratches.length) return;

    if (!('IntersectionObserver' in window)) {
      scratches.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    scratches.forEach(function (el) {
      io.observe(el);
    });
  }

  // Runs in <head>, before the PDP body markup exists yet — wait for the
  // DOM to actually be parsed instead of querying an empty NodeList.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
